import { SoapType } from 'src/types';
export var checkIsDoctorSoap = function checkIsDoctorSoap(soap_type) {
  return soap_type === SoapType.flc_first;
};